import Vue from 'vue';
import {DEVICE_TYPE} from '@graphql';
import apolloClient from '@apolloClient';
import {convertValueByParam, hardwareVersionToName} from '../../util';

const deviceTypeIconMap = {
  GSM_GATEWAY: '/device-icons-v2/main-unit.png',
  GSM_GATEWAY_TDR: '/device-icons-v2/main-unit.png',
  GSM_GATEWAY_IR_TDR: '/device-icons-v2/main-unit.png',
  GSM_NODE1: '/device-icons-v2/irrigation-unit.png',
  GSM_NODE1_TDR: '/device-icons-v2/irrigation-unit.png',
  GSM_NODE1_IR_TDR: '/device-icons-v2/irrigation-unit.png',
  GSM_NODE2: '/device-icons-v2/soil-moisture-unit.png',
  GSM_NODE3: '/device-icons-v2/soil-moisture-unit.png',
  GSM_NODE4: '/device-icons-v2/soil-moisture-unit.png',
  GSM_NODE4_TDR: '/device-icons-v2/soil-moisture-unit.png',
  GSM_NODE4_IR_TDR: '/device-icons-v2/soil-moisture-unit.png',
  GSM_NODE5: '/device-icons-v2/nursery-unit.png',
  GSM_POLYHOUSE: '/device-icons-v2/poly-house-unit.png',
  WAN_NODE6: '/device-icons-v2/soil-moisture-unit.png',
  WAN_NODE6_TDR: '/device-icons-v2/soil-moisture-unit.png',
  WAN_NODE6_IR_TDR: '/device-icons-v2/soil-moisture-unit.png',
  GSM_NODE6: '/device-icons-v2/soil-moisture-unit.png',
  GSM_NODE6_TDR: '/device-icons-v2/soil-moisture-unit.png',
  GSM_NODE6_IR_TDR: '/device-icons-v2/soil-moisture-unit.png',
  GSM_WATER_LEVEL: '/device-icons-v2/soil-moisture-unit.png'
};

const codeSensorMap = {
  TC: 'Temperature',
  HUM: 'Humidity',
  PRES: 'Air pressure',
  SOIL_B: 'Soil mositure l1',
  SOIL_C: 'Soil mositure l2',
  SOILTC: 'Soil temprature',
  ANE: 'Wind speed',
  WV: 'Wind direction',
  PLV1: 'Rainfall',
  LW: 'Leaf wetness',
  SOIL_D: 'Soil mositure l3',
  SOIL_E: 'Soil mositure l4',
  LDR: 'Solar radiation',
  LUX: 'Solar intensity',
  BAT: 'Battery',
  BATV: 'Battery voltage',
  RSSI: 'Signal strength',
  PLV2: 'Rainfall',
  PLV3: 'Rainfall',
  VWC_1: 'Soil Moisture Volumetric l1',
  VWC_2: 'Soil Moisture Volumetric l2',
  VWC_3: 'Soil Moisture Volumetric l3',
  VWC_4: 'Soil Moisture Volumetric l4',
  EC: 'EC',
  PH: 'PH',
  WL: 'Water level'
};

const deviceTypeNameMap = {};

const getDeviceType = async () => {
  const deviceTypesResponse = await apolloClient.query({
    query: DEVICE_TYPE
  });
  const deviceTypesRes = deviceTypesResponse.data.deviceTypeList;
  for (let i = 0; i < deviceTypesRes.length; i += 1) {
    if (!deviceTypeNameMap[deviceTypesRes[i].version]) {
      deviceTypeNameMap[deviceTypesRes[i].version] = {};
    }
    if (!deviceTypeNameMap[deviceTypesRes[i].version][deviceTypesRes[i].identifier]) {
      deviceTypeNameMap[deviceTypesRes[i].version][deviceTypesRes[i].identifier] = deviceTypesRes[i].name;
    }
  }
};

getDeviceType();

Vue.mixin({
  methods: {
    convertValueByParam(param, value) {
      return convertValueByParam(param, value);
    },
    deviceIcon(deviceType) {
      return deviceTypeIconMap[deviceType] ? deviceTypeIconMap[deviceType] : deviceTypeIconMap.GSM_NODE4;
    },
    sensorName(sensor) {
      return codeSensorMap[sensor];
    },
    deviceName(hardwareVersion, deviceType) {
      return (deviceTypeNameMap[hardwareVersion] && deviceTypeNameMap[hardwareVersion][deviceType]) || deviceType;
    },
    hardwareVersionToName
  }
});
